import { eventsConstants } from './eventsList'

const mixpanelEvent = {
  computed: {
    eventsConstants() {
      return eventsConstants
    },
  },
  methods: {
    sendMixpanelEvent(event, payload) {
      this.$store.dispatch('content/sendMixpanelEvent', {
        event_name: event,
        properties: {
          ...payload,
        },
      })
    },
  },
}

export const localTimezone = {
  computed: {
    localTimeZone() {
      return Intl.DateTimeFormat()
        .resolvedOptions()
        .timeZone.replace(/_/g, ' ')
    },
  },
}

export const bootcampCommons = {
  computed: {
    learningAreaName() {
      const {
        bootcamp: { learning_areas },
      } = this
      return learning_areas && learning_areas[0] && learning_areas[0].name
        ? learning_areas[0].name
        : 'IT Essentials'
    },
    contentInstructors() {
      const content = this.bootcamp || this.parent
      if (content.instructors.length === 2) {
        return `${content.instructors[0].name} and ${content.instructors[1].name}`
      }
      const twoFirst = content.instructors
        .slice(0, 2)
        .map(item => {
          return item.name ? item.name : 'INE Instructor'
        })
        .join(', ')
      return `${twoFirst}${
        content.instructors.length > 2
          ? ` and ${content.instructors.length - 2} more`
          : ''
      }`
    },
  },
  methods: {
    getInstructorImg(instructor) {
      return instructor.profile_img_url
        ? instructor.profile_img_url
        : require('@/assets/images/instructor_fallback.png')
    },
    getInstructorName(instructor) {
      return instructor.name ? instructor.name : 'INE Instructor'
    },
  },
}

export default mixpanelEvent
